<div class="container">
  <div class="payment-card">
    @if (!orderConfirmed) {
    <div class="animate-fade-in">
      <h2 class="card-title">Complete Your Payment</h2>
      <p class="card-subtitle">Please fill out the details below to complete your order.</p>

      <form #paymentForm="ngForm" (ngSubmit)="onSubmit()" class="payment-form">
        <div class="form-group">
          <label for="package" class="form-label">Select Package</label>

          <select id="package" name="packageId" [(ngModel)]="selectedPackageId" class="form-control" required>
            @for (pkg of packages; track pkg.PackageID) {
            <option [ngValue]="pkg.PackageID">
              {{ pkg.PackageName + " - " + (pkg.FinalAmount | currency : "INR") }}
            </option>
            }
          </select>
        </div>

        <div class="form-group">
          <label for="payeeName" class="form-label">Payee Name</label>
          <input type="text" id="payeeName" name="payeeName" onlyCharacter [(ngModel)]="paymentData.PayeeName" placeholder="e.g., John Doe" class="form-control" required />
        </div>

        <div class="form-group">
          <label for="payeeNumber" class="form-label">Payee Mobile Number</label>
          <input type="tel" id="payeeNumber" name="payeeNumber" onlyNumber maxlength="10" [(ngModel)]="paymentData.PayeeMobileNo" placeholder="e.g., 1234567891" class="form-control" required />
        </div>

        <div class="form-group">
          <label for="discount" class="form-label">Discount</label>
          <input type="number" id="discount" name="discount" allowDecimal [(ngModel)]="paymentData.Discount" placeholder="0.00" class="form-control" />
        </div>

        <div class="form-group">
          <label for="paymentMethod" class="form-label">Payment Method</label>

          <select id="paymentMethod" name="paymentMethod" [(ngModel)]="paymentData.PTID" class="form-control" required>
            @for (pkg of paymentModeMaster; track pkg.PTID) {
            <option [ngValue]="pkg.PTID">
              {{ pkg.PTName }}
            </option>
            }
          </select>
        </div>

        @switch (paymentData.PaymentMethod) { @case ('UPI') {
        <div class="upi-container animate-fade-in">
          <h3 class="upi-title">Scan QR to Pay</h3>
          <svg class="qr-code" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <path
              fill="#374151"
              d="M10,10 h20 v20 h-20 z M40,10 h10 v10 h-10 z M60,10 h10 v20 h-10 z M80,10 h10 v10 h-10 z M10,40 h10 v10 h-10 z M40,40 h30 v30 h-30 z M80,40 h10 v10 h-10 z M10,60 h20 v10 h-20 z M40,80 h10 v10 h-10 z M60,80 h30 v10 h-30 z M10,80 h10 v10 h-10 z M0,0 h100 v100 h-100 z"
              fill-rule="evenodd" />
          </svg>
          <p class="upi-instructions">Scan the code with your favorite UPI app.</p>
        </div>
        } @case ('Card') {
        <div class="card-form animate-fade-in">
          <div class="form-group">
            <label for="cardNumber" class="form-label">Card Number</label>
            <input type="text" id="cardNumber" placeholder="•••• •••• •••• ••••" class="form-control" />
          </div>
          <div class="card-details-row">
            <div class="form-group">
              <label for="expiryDate" class="form-label">Expiry</label>
              <input type="text" id="expiryDate" placeholder="MM / YY" class="form-control" />
            </div>
            <div class="form-group"><label for="cvv" class="form-label">CVV</label> <input type="text" id="cvv" placeholder="•••" class="form-control" /></div>
          </div>
        </div>
        } }
        <div class="summary">
          <div class="summary-row">
            <span>Payment Mode:</span>
            <span class="payment-mode">{{ paymentData.PaymentMethod }}</span>
          </div>
          <div class="summary-row">
            <span>Amount:</span>
            <span>{{ selectedPackage?.FinalAmount | currency : "INR" }}</span>
          </div>
          <div class="summary-row discount">
            <span>Discount:</span>
            <span>- {{ paymentData.Discount | currency : "INR" }}</span>
          </div>
          <div class="summary-divider"></div>
          <div class="summary-row total">
            <span>Total Due:</span>
            <span class="total-amount">{{ totalAmount | currency : "INR" }}</span>
          </div>
        </div>

        <button type="submit" [disabled]="paymentForm.invalid" class="btn-confirm">
          {{ paymentData.PaymentMethod === "Cash" ? "Confirm Payment" : "Pay " + (totalAmount | currency : "INR") }}
        </button>
      </form>
    </div>
    } @else {
    <div class="confirmation-view animate-fade-in">
      <div class="order-summary-box">
        <div class="summary-row">
          <span class="label">Payee:</span> <strong>{{ paymentData.PayeeName }}</strong>
        </div>
      </div>
      <div class="new-order-link-container">
        <a href="javascript:void(0);" (click)="reset()" class="new-order-link"> &larr; Place Another Order </a>
      </div>
    </div>
    }
  </div>
</div>
